// extracted by mini-css-extract-plugin
module.exports = {"inner":"two-columns-module--inner--1vO82","leftColumn":"two-columns-module--leftColumn--CXUgS","rightColumn":"two-columns-module--rightColumn--1Tvig"};